module.exports = __webpack_public_path__ + "img/mobile-advert-maf.f606c4d4.jpeg";